export type DepositNameConflict = {
  name: string;
  origin: 'manual' | 'm365_sharepoint';
};

export function normalizeDepositName(name: string) {
  return name.trim().replace(/\s+/g, ' ').toLocaleLowerCase('fr');
}

export function partitionDepositFiles<T extends { name: string }>(
  files: readonly T[],
  conflicts: readonly DepositNameConflict[],
) {
  const byName = new Map(conflicts.map((conflict) => [normalizeDepositName(conflict.name), conflict]));
  const fresh: T[] = [];
  const manual: T[] = [];
  const sharepoint: T[] = [];

  for (const file of files) {
    const hit = byName.get(normalizeDepositName(file.name));
    if (!hit) {
      fresh.push(file);
    } else if (hit.origin === 'm365_sharepoint') {
      sharepoint.push(file);
    } else {
      manual.push(file);
    }
  }

  return { fresh, manual, sharepoint };
}
